import React from "react";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import BrandMark from "./BrandMark";

const PHONE_PRIMARY = "(778) 868-0678";
const PHONE_SECONDARY = "(604) 417-2754";
const EMAIL = "pneuprocomp@gmail.com";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-black text-slate-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <BrandMark className="h-16 w-16" />
            <div className="leading-none">
              <div className="font-heading font-black text-2xl tracking-tight uppercase text-white">
                Pneupro
              </div>
              <div className="text-[11px] font-bold tracking-[0.18em] uppercase text-slate-400">
                Air Compressor Services Ltd.
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-slate-400 max-w-sm">
            Top-notch, cost-effective service for industrial air compressor systems across British
            Columbia. Repairs, maintenance, and after-hours service available.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-blue-400 mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-slate-500" />
              <a data-testid="footer-phone-primary" href={`tel:+1${PHONE_PRIMARY.replace(/\s|\(|\)|-/g, "")}`} className="hover:text-white">
                {PHONE_PRIMARY} <span className="block text-xs text-slate-500">Phone</span>
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-slate-500" />
              <a data-testid="footer-phone-secondary" href={`tel:+1${PHONE_SECONDARY.replace(/\s|\(|\)|-/g, "")}`} className="hover:text-white">
                {PHONE_SECONDARY} <span className="block text-xs text-slate-500">Phone</span>
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-slate-500" />
              <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="hover:text-white break-all">
                {EMAIL}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-slate-500" />
              <div data-testid="footer-location">
                Surrey, British Columbia
                <span className="block text-xs text-slate-500">Headquarters</span>
              </div>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-blue-400 mb-4">
            Hours
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 text-slate-500" />
              <div data-testid="footer-hours">
                Mon–Fri 7:00am – 3:00pm
                <span className="block text-xs text-slate-500">Office hours</span>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 text-blue-400" />
              <div data-testid="footer-after-hours">
                After-hours service available
                <span className="block text-xs text-blue-400/80">On request, by appointment</span>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-slate-500" />
              <div data-testid="footer-region">Service Region: British Columbia</div>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-blue-400 mb-4">
            Internal
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                data-testid="footer-admin-link"
                href="/admin/login"
                className="hover:text-white inline-flex items-center gap-1"
              >
                Admin Portal →
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div data-testid="footer-copyright">
            © {year} Pneupro Air Compressor Services Ltd. · Surrey, British Columbia.
          </div>
          <div className="font-bold tracking-[0.2em] uppercase text-slate-600">
            Industrial Precision · Engineered Service
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
